<template>
  <div class="h-[1px] bg-back-4"></div>
</template>
